import React, { useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import {
  Paper,
  MenuItem,
  IconButton,
  Dialog,
  Typography,
  Box,
} from "@mui/material";
import { Delete as DeleteIcon, OpenInNewSharp } from "@mui/icons-material";
import { useAuthUser } from "react-auth-kit";
import columns from "./TelemonitoraggiColumns";
import PageTitle from "../../components/PageTitle/PageTitle";
import { ViewPatient } from "../../components/PatientComponents";
import {
  LoadingError,
  LoadingPaper,
  EmptyPaper, 
} from "../../components/LoadingComponents";
import {
  useDeleteService,
  useGetServices,
} from "../../components/ServiceComponents";

function Telemonitoraggi(props) {
  // === authentication ===
  const authUser = useAuthUser();

  // === web service querying ===
  const servicesQuery = useGetServices(true);
  const deleteMutation = useDeleteService();

  // === ViewPatient modal handling ===
  const [openViewPatient, setOpenViewPatient] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const handleOpenViewPatient = (patient_id) => {
    // set patient data
    setSelectedPatient(patient_id);
    setOpenViewPatient(true);
  };
  const handleCloseViewPatient = () => {
    setOpenViewPatient(false);
  };

  const tableColumns = columns(handleOpenViewPatient);

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openViewPatient} fullScreen>
        <ViewPatient
          _editMode={false}
          patient_id={selectedPatient}
          closeModal={handleCloseViewPatient}
        />
      </Dialog>

      <PageTitle title="Telemonitoraggi" />
      {servicesQuery.isLoading || servicesQuery.data === undefined ? (
        <LoadingPaper />
      ) : servicesQuery.isError ? (
        <>
          <LoadingError error={servicesQuery.error} />
        </>
      ) : servicesQuery.isSuccess &&
        servicesQuery.data.services.length === 0 ? (
        <EmptyPaper message={"Nessun telemonitoraggio"} />
      ) : (
        <Paper
          style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
        >
          <MaterialReactTable
            columns={tableColumns}
            data={servicesQuery.data?.services || []}
            initialState={{
              density: "compact",
              showColumnFilters: true,
              columnVisibility: {
                professionista_sanitario: authUser()?.role !== 3,
                org_name: authUser()?.role === 1,
              },
            }}
            enablePagination={true}
            enableBottomToolbar={true}
            enableTopToolbar={false}
            enableSorting={true}
            enableFacetedValues
            muiTablePaperProps={{
              elevation: 0,
            }}
            muiTableContainerProps={{
              sx: {
                overflowX: "hidden",
              },
            }}
            enableColumnResizing
            enableColumnActions={false}
            enableRowSelection={false}
            enableRowActions={true} // NO ROW ACTIONS FOR NOW
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Azioni" },
            }}
            positionActionsColumn="last"
            renderRowActionMenuItems={({ closeMenu, row, table }) => [
              <MenuItem
                key="delete"
                onClick={() => {
                  deleteMutation.mutate(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  <DeleteIcon color="error" />
                </IconButton>
                Elimina
              </MenuItem>,
            ]}
          />
        </Paper>
      )}
    </main>
  );
}

export default Telemonitoraggi;
